/** Lord of Riches US loginOptions 文案（现网 american* i18n） */
export const lorUsAuthCopy = {
  confirm: 'OK',
  enterSms: 'Enter SMS',
  guest: 'Guest',
  loading: 'Loading',
  or: 'or',
  pageTitle: 'Login/Register',
  phoneError: 'Please enter a valid phone number',
  phonePre: '+1',
  smsFail: 'Failed to send SMS',
  smsName: 'SMS',
  smsSuccess: 'SMS sent successfully',
  telephone: 'Telephone',
  /** 源站 totalReward = guestSendMoney + registerSendMoney，截图为 15 */
  defaultReward: 15,
} as const;
